import {ColumnGroup} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';

export default function doesColumnMatchTypeAndGroup(
  column: StructuredTableColumn,
  columnType: TableColumnType,
  columnGroup: ColumnGroup | null
): boolean {
  return column.columnType === columnType && (column.columnGroup ?? null) === columnGroup;
}
